/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Review_Status_Not_ResolvableInputs */

const es_co2_error_review_status_not_resolvable = /** @type {(inputs: Error_Review_Status_Not_ResolvableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este formulario no se puede resolver desde este borrador.`)
};

/**

* @param {Error_Review_Status_Not_ResolvableInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const error_review_status_not_resolvable = /** @type {((inputs?: Error_Review_Status_Not_ResolvableInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Review_Status_Not_ResolvableInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_error_review_status_not_resolvable(inputs)
});